/* eslint-disable react/jsx-curly-brace-presence */
// eslint-disable-next-line react/prefer-stateless-function

import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import AnniversaryBanner from '../../images/FullHD_SU22_50th_HeroArt_16x9.jpg';
import Steve from '../../images/Steve.png';
import LunarNewYear from '../../images/ASCEND_LNY21_HIGHFIVE.jpg'
import wonBanner1 from '../../images/H5_WON_March_1.jpg'
import wonBanner2 from '../../images/H5_WON_March_2.jpg'
import lhmBanner2 from '../../images/HighFive_LHM_2.jpg'
import prideBannerNike from '../../images/H5_Pride_Nike_Banner.png'
import prideBannerConverse from '../../images/H5_Pride_Converse_Banner.png'
import ConverseBanner from '../../images/Converse_hero.jpg'
import converseAllStar from '../../images/H5_Converse_AllStars.jpg'
import Arrow from '../../images/Arrow.svg';
import { getRandomValue } from '../../lib/auth.utils';
import SubmitForm from '../SubmitForm/SubmitForm';
import ConfirmationPage from '../ConfirmationPage/ConfirmationPage';
import pageCopy from "../../copy"

// NOTE :: This URL shows detailed config and endpoint info for an Okta app:
// https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/.well-known/openid-configuration?response_type=id_token%20token&client_id=nike.nikedigital.highfive&scope=profile%20openid%20email&redirect_uri=highfive.nike.com&state=STATE_STRING&nonce=NONCE_STRING
const oktaUrl = process.env.REACT_APP_OKTA_URL;
const nonce = getRandomValue();
const state = getRandomValue();
const authParams = [
  'client_id=nike.nikedigital.highfive',
  `redirect_uri=${window.location.origin}/okta-redirect`,
  'response_type=id_token%20token',
  'scope=profile%20openid%20email',
  `nonce=${nonce}`,
  `state=${state}`
].join('&');
const authUrl = `${oktaUrl}/v1/authorize?${authParams}`;

/*
  # WON banner -- March
  # PRIDE banner -- June
  # LHM banner -- Sept 15 - Oct 15
  # Converse All Stars -- Sept 17 - Oct 16
*/

const currentTheme = () => {
  const now = new Date();
  const currentMonth = now.getMonth() + 1;
  const currentDate = now.getDate();
  let banner;
  let blurb;
  let theme;
  let alt;
  let ariaLabel;

  console.log(currentDate)

  const anniversary = true;
  if (anniversary) {
    return {
      'banner': AnniversaryBanner,
      'theme': 'default',
      'alt': 'Nike 50th Anniversary - We Are Never Done',
      'ariaLabel': 'Nike 50th Anniversary - We Are Never Done'
    }
  }

  // Banner selection
  if ((currentMonth === 2 && (currentDate > 7 && currentDate < 13))
    && window.sessionStorage.company === 'nike') {
    banner = LunarNewYear
    blurb = `The Ascend Network invites you to celebrate Lunar New Year, 
        the year of the Ox, by giving a teammate a red envelope. Recognized 
        in many cultures as a gesture of kindness, a red envelope symbolizes 
        the wish of luck and good fortune for its recipient.`
  } else if (currentMonth === 3 && window.sessionStorage.company === 'nike') {
    banner = Math.round(Math.random()) === 0 ? wonBanner1 : wonBanner2;
    blurb = `Throughout Women’s History Month, give a digital high five to recognize
      the valiant women you work with every day whose voices
      change the world through their work, expertise, sport and culture!`;
  } else if (currentMonth === 6 && window.sessionStorage.company === 'nike') {
    banner = prideBannerNike;
  } else if (currentMonth === 6 && window.sessionStorage.company === 'converse') {
    banner = prideBannerConverse;
  } else if (
    ((currentMonth === 9 && currentDate > 14) || (currentMonth === 10 && currentDate < 16)) &&
    window.sessionStorage.company === 'nike'
  ) {
    banner = lhmBanner2;
    blurb = `Throughout Latino Heritage Month (LHM),
      join us in celebrating our diverse cultures via this year’s theme,
      ¡The Voz (voice) ! The Voz is powerful, the voz is bold,
      the voz is passionate, and our voz is creating a movement
      that influences culture, music, sport, and the places we work.
      Amplify the voices of those around you all LHM long with a virtual high five!`
    alt = 'Latino Heritage Month banner'
    ariaLabel = 'Latino Heritage Month banner'
  } else if (
    ((currentMonth === 9 && currentDate > 16) || (currentMonth === 10 && currentDate < 17)) &&
    window.sessionStorage.company === 'converse'
  ) {
    banner = converseAllStar;
    theme = 'converseAllStar'
    alt = 'Converse All Stars banner'
    ariaLabel = 'Converse All Stars banner'
  }

  // Default Theme
  if (!banner)
    return window.sessionStorage.company === 'converse' ?
      {
        'banner': ConverseBanner,
        'theme': 'default'
      } :
      {
        'banner': Steve,
        'theme': 'default',
        'alt': 'Steve Prefontaine - To give anything less than your best is to sacrifice the gift',
        'ariaLabel': 'Steve Prefontaine - To give anything less than your best is to sacrifice the gift'
      };

  // Current Theme
  return {
    'banner': banner,
    'theme': theme,
    'blurb': blurb,
    'alt': alt,
    'ariaLabel': ariaLabel
  }

};

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmSubmitted: false,
      user: props.user,
      userName: props.user.name,
      currentTheme: currentTheme()
    };
    this.confirmationAfterSubmitted = this.confirmationAfterSubmitted.bind(this);
  }

  componentWillMount() {
    if (this.state.userName === null) {
      window.location.assign(authUrl);
    }
  }

  confirmationAfterSubmitted = isSubmitted => {
    this.setState({
      confirmSubmitted: isSubmitted
    });
  };

  render() {
    if (isMobile) {
      return (
        <div>
          <div className="ncss-col-sm-12">
            <div
              className="ncss-col-sm-12"
              style={{
                height: '675px'
              }}
            >
              {!this.state.confirmSubmitted && (
                <SubmitForm
                  onConfirmSubmit={this.confirmationAfterSubmitted}
                  user={this.state.user}
                  history={this.props.history}
                />
              )}
              {this.state.confirmSubmitted && <ConfirmationPage />}
            </div>
          </div>
        </div>
      )
    }
    return (
      <div>
        <div>
          <div className="ncss-col-sm-12">
            <div
              className="ncss-col-sm-12"
              // style={{
              //   height: '675px'
              // }}
            >
              {!this.state.confirmSubmitted && (
                <SubmitForm
                  onConfirmSubmit={this.confirmationAfterSubmitted}
                  user={this.state.user}
                  history={this.props.history}
                />
              )}
              {this.state.confirmSubmitted && <ConfirmationPage />}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

LoginPage.propTypes = {
  user: PropTypes.object,
  history: PropTypes.object.isRequired
};

LoginPage.defaultProps = {
  user: {}
};

export default LoginPage;



// WEBPACK FOOTER //
// ./src/containers/LoginPage/LoginPage.js